module.exports = __webpack_public_path__ + "static/media/mk.4a879fde.svg";